import { CustomerValidation } from '../types';

const initCustomerValid: CustomerValidation = {
  Name: { isErr: false, errMsg: '', canNotSave: true },
  TypeId: { isErr: false, errMsg: '', canNotSave: true },
  WorkEmail: { isErr: false, errMsg: '', canNotSave: false },
  PersonalEmail: { isErr: false, errMsg: '', canNotSave: false },
  OtherEmail: { isErr: false, errMsg: '', canNotSave: false },
};

export const loadedCustomerValid: CustomerValidation = {
  Name: { isErr: false, errMsg: '', canNotSave: false },
  TypeId: { isErr: false, errMsg: '', canNotSave: false },
  WorkEmail: { isErr: false, errMsg: '', canNotSave: false },
  PersonalEmail: { isErr: false, errMsg: '', canNotSave: false },
  OtherEmail: { isErr: false, errMsg: '', canNotSave: false },
};

export default initCustomerValid;
